var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "selectSource"
  }, [_vm.$route.name == 'party' || _vm.$route.name == 'partyParticipate' || _vm.useNewUi ? _c('el-cascader', {
    attrs: {
      "clearable": "",
      "no-match-text": "No Data",
      "no-data-text": "No Data",
      "popper-class": "liveCascader",
      "placeholder": _vm.$t('pushParticipantSource.specialDestination'),
      "options": _vm.allRList,
      "filterable": "",
      "before-filter": _vm.beforeFilter,
      "disabled": _vm.showSelectBox
    },
    on: {
      "change": _vm.changeNewR,
      "expand-change": _vm.changeExpand,
      "visible-change": val => {
        if (val) _vm.getNewSourceList('getReceiverList', val);
      }
    },
    nativeOn: {
      "input": function ($event) {
        return _vm.iptChange.apply(null, arguments);
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        data
      }) {
        return [_c('div', {
          directives: [{
            name: "scroll",
            rawName: "v-scroll",
            value: _vm.scroll,
            expression: "scroll"
          }],
          class: {
            list: data.type === 'R'
          }
        }, [_c('span', [_vm._v(_vm._s(_vm.showLabel(data)))]), _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": _vm.$t('common.versionText'),
            "placement": "top"
          }
        }, [_c('i', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: data.label === 'Receiver',
            expression: "data.label === 'Receiver'"
          }],
          staticClass: "iconfont icon-help2"
        })]), data.userInfo ? _c('p', [_vm._v(_vm._s(data.userInfo.email))]) : _vm._e(), data.label === 'Receiver' && !data.children ? _c('span', {
          staticStyle: {
            "margin-left": "26px",
            "color": "#C0C4CC"
          }
        }, [_vm._v(_vm._s(_vm.$t('common.noReceiver')))]) : _vm._e(), data.label === 'Producer' && !data.children ? _c('span', {
          staticStyle: {
            "margin-left": "22px",
            "color": "#C0C4CC"
          }
        }, [_vm._v(_vm._s(_vm.$t('common.noProgram')))]) : _vm._e()], 1)];
      }
    }], null, false, 2838684353),
    model: {
      value: _vm.sourceId,
      callback: function ($$v) {
        _vm.sourceId = $$v;
      },
      expression: "sourceId"
    }
  }) : _c('el-select', {
    attrs: {
      "clearable": "",
      "remote": "",
      "placeholder": _vm.$t('pushParticipantSource.specialDestination'),
      "popper-class": "gallery-r-select",
      "filterable": true,
      "no-match-text": "No Data",
      "no-data-text": "No Data",
      "filter-method": val => {
        _vm.getSourceList('filter', val);
      }
    },
    on: {
      "change": _vm.changeR,
      "visible-change": val => {
        _vm.getSourceList('getReceiverList', val);
      }
    },
    model: {
      value: _vm.sourceId,
      callback: function ($$v) {
        _vm.sourceId = $$v;
      },
      expression: "sourceId"
    }
  }, _vm._l(_vm.allRList, function (group) {
    return _c('el-option-group', {
      key: group.label,
      attrs: {
        "label": group.label
      }
    }, _vm._l(group.options, function (item) {
      return _c('el-option', {
        key: item.value,
        class: {
          red: _vm.liveInfo.peerId == item.peerId && _vm.liveInfo.channel == _vm.partyCode
        },
        attrs: {
          "disabled": _vm.talkBack && item.peerId.includes('fffff'),
          "label": item.name,
          "value": item.peerId
        }
      });
    }), 1);
  }), 1), _c('el-button', {
    staticClass: "green-gradient",
    class: _vm.returnColorClass,
    on: {
      "click": function ($event) {
        return _vm.startOrStop();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.shouldShowStop ? _vm.$t('audioChannels.stop') : _vm.$t('remainWords.live')) + " "), _vm.loading ? _c('i', {
    staticClass: "el-icon-loading"
  }) : _vm._e()]), _c('TipsDailog', {
    attrs: {
      "info": _vm.tipsInfo,
      "showClose": false
    },
    on: {
      "save": _vm.switchLive,
      "cancel": _vm.cancelSwitch
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };